import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appAlphaNumericOnly]'
})
export class AlphaNumericOnlyDirective {

    // Allow only alphabets (A-Z, a-z) and numbers (0-9)
    private regex: RegExp = new RegExp(/^[a-zA-Z0-9]*$/);

    @HostListener('keypress', ['$event'])
    onKeyPress(event: KeyboardEvent) {
        const inputChar = String.fromCharCode(event.charCode);
        if (!this.regex.test(inputChar)) {
            event.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        const clipboardData = event.clipboardData || (window as any).clipboardData;
        const pastedInput: string = clipboardData.getData('text') || '';
        if (!this.regex.test(pastedInput)) {
            event.preventDefault();
        }
    }
}
